/**
 * Sorting values.
 *
 * @enum {string}
 */
module.exports = {
    ASCENDENT: 'asc',
    DESCENDENT: 'desc'
};
